// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__ujSud","formSpace":"styles_formSpace__32ecW"};